import { ParticipantSearchResponse } from '../../store/participants';

export enum StoreStatus {
  BUSY = 'busy',
  IDLE = 'idle',
  ERROR = 'error',
}

export enum ParticipantStatus {
  ACTIVE = 'ACTIVE',
  DECEASED = 'DECEASED',
  WITHDRAWN = 'WITHDRAWN',
  SUSPENDED = 'SUSPENDED',
  LOC = 'LOC',
}

export enum EhrStatus {
  PENDING = 'PENDING',
  DECEASED = 'DECEASED',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

export enum OrderStatus {
  PENDING = 'PENDING',
  HOLD = 'HOLD',
  CONFIRMED = 'CONFIRMED',
  CREATED = 'CREATED',
  DISPATCHED = 'DISPATCHED',
  RECEIVED = 'RECEIVED',
  STORED = 'STORED',
  SHIPPED = 'SHIPPED',
  QCFAIL = 'QCFAIL',
  QCSUCCESS = 'QCSUCCESS',
  DESTROYED = 'DESTROYED',
  PROCESSED = 'PROCESSED',
}

export enum OrderCondition {
  Viable = 'Viable',
  'Non-viable' = 'Non-viable',
}

export interface GraphQlErrorLocation {
  line: number;
  column: number;
  sourceName: string | null;
}

export interface GraphQlError {
  path: string[];
  data: string | null;
  errorType: string;
  errorInfo: string | null;
  locations: GraphQlErrorLocation[];
  message: string;
}

export interface Participant {
  firstName: string;
  surname: string;
  address1: string;
  address2: string;
  town: string;
  postcode: string;
  genderIdentity: string;
  sexAtBirth: string;
  dob: string;
  nhsNumber: string;
  landline: string;
  mobile: string;
  email: string;
  communicationOptIn: boolean;
  enrolmentTs: string;
  participantId: string;
  participantRef: string;
  participantStatus: ParticipantStatus;
  withdrawalLevel: string | null;
  withdrawalReason: string | null;
  withdrawalTs: string | null;
  consent1: boolean;
  consent2: boolean;
  consent3: boolean;
  consent4: boolean;
  consent5: boolean;
  consent6: boolean;
  consent7: boolean;
  consent8: boolean;
  consent9: boolean;
  consentFormDate: string;
  consentFormVersion: string;
  pisDate: string;
  pisVersion: string;
  pisConfirm: boolean;
  videoConfirm: boolean;
  privacyAccepted: boolean;
  termsAccepted: boolean;
  termsVersion: string;
  ancestryOptIn: boolean;
  ehrOptIn: boolean;
  site: ParticipantSite;
  ehr: ParticipantEhr;
  sample: ParticipantSample;
  lab: ParticipantLab;
}

export interface ParticipantSite {
  odsCode: string;
  siteName: string;
  siteSystem: string;
  siteAddress1: string;
  siteAddress2: string;
  siteTown: string;
  sitePostcode: string;
  isInitiated: boolean;
}

export interface ParticipantEhr {
  dataHasArrivedTs: string | null;
  ehrIsLoc: boolean;
  ehrStatus: EhrStatus;
  ehrUpdatedTs: string | null;
  ehrIsDeceased: boolean;
  ehrUpdates: EhrStatusUpdate[];
}

export interface EhrStatusUpdate {
  ehrStatus: EhrStatus;
  ehrIsLoc: boolean;
  ehrIsDeceased: boolean;
  ehrUpdatedTs: string | null;
}

export interface ParticipantSample {
  sampleLinkTs: string | null;
  sampleBarcode: string;
  sampleReceivedTs: string | null;
  sampleReminderSent: boolean;
  sampleViable: boolean | null;
  orderStatus: OrderStatus;
  orderNum: string;
  orderSequencer: string;
  orderUpdatedTs: string | null;
  sampleUpdates: SampleStatusUpdate[];
}

export interface SampleStatusUpdate {
  orderStatus: OrderStatus;
  orderNum: string;
  orderRef: string;
  orderSequencer: string;
  orderUpdatedTs: string;
}

export interface ParticipantLab {
  sampleBarcode: string;
  boxBarcode: string | null;
  samplePosition: string | null;
  shipped: boolean;
  shippedDate: string | null;
}

export interface Site {
  name: string;
  address1: string;
  address2: string;
  postcode: string;
  code: string;
  initiated: boolean;
  provider?: string | null;
}

// CHECK WEHRE THIS STUFF GOES
// export interface ParticipantSearch {
//   keyword: string;
// }

export type ParticipantSearchResponseFull = {
  data?: {
    searchParticipants: ParticipantSearchResponse;
  };
  errors?: GraphQlError[];
};

export type ParticipantResponse = {
  data?: {
    getParticipant: Participant;
  };
  errors?: GraphQlError[];
};

// site responses
export type SiteResponse = {
  data?: {
    getSite: Site;
  };
  errors?: GraphQlError[];
};
